/* Draft-Interim (27.07.): tauscht das Liposomal-Beitragsbild nur im
   Redesign-Theme gegen die Markenfarben-Version (Asset eg-blog-liposom.jpg).
   Final soll das Bild regulaer am Artikel ersetzt werden (Shopify Admin) —
   dann diese Datei + theme.liquid-Einbindung entfernen. */
(function () {
  var NEU = null;
  document.querySelectorAll('img').forEach(function (img) {
    if (!/Blog-Liposome_/.test(img.src || '') && !/Blog-Liposome_/.test(img.getAttribute('srcset') || '')) return;
    if (!NEU) {
      var probe = document.querySelector('script[src*="eg-article-swap"]');
      NEU = probe ? probe.src.replace(/eg-article-swap\.js.*$/, 'eg-blog-liposom.jpg') : null;
    }
    if (!NEU) return;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.src = NEU;
  });
})();
